<template>
  <div class="directory-container">
    <div class="heading">
      <h3 :style="{ 'font-weight': '700', 'font-size': '32px', 'line-height': '42px', color: '#0F1734' }">
        My Dove Directory
      </h3>
      <div class="d-flex flex-row private-container">
        <font-awesome-icon class="mr-2" :style="{ color: '#647490', width: '12.4px' }" :icon="['fas', 'eye-slash']" />
        <p class="private">Private to you</p>
      </div>
    </div>
    <p class="sub-title">
      The Dove Directory is intended to help users have quick access to their saved healthcare providers, medical professionals, hospitals, clinics and healthcare businesses.
    </p>
    <div class="mb-3">
      <span @click="handleBack" :style="{ color: getPrimaryColor(), cursor: 'pointer' }">
        <font-awesome-icon class="mr-2" :style="{ color: getPrimaryColor() }" :icon="['fas', 'arrow-left']" />
        Back</span
      >
    </div>
    <h4 class="saved-title">Saved {{ title }}</h4>

    <div v-if="loading" class="d-flex justify-content-center mt-3">
      <div>
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">
        Loading...
      </div>
    </div>

    <div v-else>
      <!-- <div v-if="role === 'doctor'">
            <div class="mb-2" v-for="data in savedFilterList" :key="data.saved.id">
            <DoveDirectoryCard
            :info="data.saved"
            :rating="data.rating"
            :review_count="data.review_count"
            :type="role"
            />
            </div>
      </div> -->

      <div class="mb-2" v-for="data in savedFilterList" :key="data.saved.id">
        <DoveDirectoryCard :info="data.saved" :rating="data.rating" :review_count="data.review_count" :core_ratings="data.core_ratings" :type="role" />
      </div>

      <div :style="{ 'margin-top': '26px', 'margin-bottom': '20px' }" class="paginationContainer">
        <a-pagination show-less-items class="dovemed-custom-pagination" :total="totalCount" :pageSize="10" v-model="CurrentPage" @change="handleChangePage" />
      </div>
    </div>
  </div>
</template>

<script>
import userRepository from "../../repositories/userRepository"
import DoveDirectoryCard from "./DoveDirectoryCard.vue"
export default {
  name: "MyDoveDirectoryFilterPage",
  data() {
    return {
      savedFilterList: [],
      title: undefined,
      role: undefined,
      loading: false,
      CurrentPage: 1,
      totalCount: undefined,
      titleBasedOnRole: { doctor: "Physicians", hcp: "Advanced Practice Providers", hospital_administrator: "Hospitals", clinic_administrator: "Clinics", nfp_administrator: "Non For Profits" },
    }
  },
  components: {
    DoveDirectoryCard,
  },

  mounted() {
    this.role = this.$route.params.role
    this.title = this.titleBasedOnRole[this.role]
    // this.title = this.$route.params.title
    // console.log(this.$route.params.role, this.$route.params.title)
    this.getMyDoveDirectoryFilterData()
  },

  methods: {
    handleBack() {
      this.$router.go(-1)
    },
    getMyDoveDirectoryFilterData() {
      this.loading = true
      userRepository
        .getMyDoveDirectory(this.CurrentPage, 10, this.currentCircle.id, this.authUser.user.id, this.authUser.user.role, this.role)
        .then(res => {
          console.log(res.data.data.data, this.savedFilterList)
          this.savedFilterList = res.data.data.data
          this.totalCount = res.data.data.paginator.total_count
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    },
    handleChangePage(page, pageSize) {
      this.getMyDoveDirectoryFilterData()
    },
  },
}
</script>

<style lang="scss" scoped>
.paginationContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.directory-container {
  .heading {
    .private {
      font-weight: 700;
      font-size: 12px;
      line-height: 14px;
      text-align: center;
      color: #647490;
    }
    .private-container {
      padding: 4px 8px;
      gap: 4px;
      width: 120px;
      height: 22px;
      background: #f1f5f9;
      border-radius: 4px;
      margin-bottom: 24px;
    }
  }

  .reviews {
    margin-top: 6px;
    text-align: center;
    p {
      margin-bottom: 0px;
    }
  }

  .sub-title {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #647490;
  }
  .saved-title {
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    color: #0f1734;
  }

  .saved {
    margin-top: 24px;
    .saved-title {
      font-weight: 700;
      font-size: 24px;
      line-height: 32px;
      color: #0f1734;
    }

    .recommend {
      align-items: center;
      padding: 4px 8px;
      gap: 4px;
      width: 115px;
      height: 22px;
      background: #f1edff;
      border-radius: 4px;
      display: flex;
      font-weight: 700;
      font-size: 12px;
      line-height: 14px;
      text-align: center;
      color: #906eff;
    }

    .king_icon {
      align-items: center;
      padding: 4px 8px;
      gap: 4px;
      width: 30px;
      height: 22px;
      background: #fff0d6;
      border-radius: 4px;
      display: flex;
    }
    .doc-name {
      font-weight: 700;
      font-size: 20px;
      line-height: 30px;
      text-transform: capitalize;
      color: #0f1734;
    }
    .tags_container {
      .tags {
        padding: 4px 8px;
        width: 70px;
        height: 22px;
        border-radius: 4px;

        .tag {
          font-weight: 700;
          font-size: 12px;
          line-height: 14px;
          text-align: center;
        }
      }
    }

    .doc-name {
      font-weight: 700;
      font-size: 20px;
      line-height: 30px;
      text-transform: capitalize;
      color: #0f1734;
    }
    .doc-number {
      font-weight: 700;
      font-size: 14px;
      line-height: 21px;
      color: #0f1734;
    }
    .doc-loc {
      font-weight: 700;
      font-size: 14px;
      line-height: 21px;
      color: #94a3b8;
      word-break: break-all;
    }

    .doc-miles {
      font-weight: 700;
      font-size: 14px;
      line-height: 21px;
      color: #0f1734;
    }

    .btns {
      .submit-btn {
        padding: 8px;
        gap: 4px;
        width: 790px;
        height: 46px;
        background: #f1f5f9;
        border-radius: 8px;
        border: none;
        align-items: center;
        display: flex;
        justify-content: center;
      }
    }

    .divider {
      border: 1px solid #cbd5e1;
    }

    .phy-name {
      width: 294px;
      height: 108px;
    }

    .phy-details {
      width: 283px;
      height: 111px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/MyDoveDirectoryFilterPage.vue